import { FC } from 'react';
import Button from '@/components/UI/Button';
import styles from './FeatureFlagConfig.module.scss';

interface FormActionsProps {
  pendingCount: number;
  isValid: boolean;
  isSubmitting: boolean;
  onDiscard: () => void;
  onSave: () => void;
}

const FormActions: FC<FormActionsProps> = ({ pendingCount, isValid, isSubmitting, onDiscard, onSave }) => {
  const hasChanges = pendingCount > 0;

  return (
    <div
      className="flex items-center"
      style={{ gap: '0.75rem' }}
      data-test-component="FormActions"
      data-test-element="container"
    >
      {hasChanges && (
        <span className={styles.pendingBadge}>
          {pendingCount} unsaved {pendingCount === 1 ? 'change' : 'changes'}
        </span>
      )}
      <Button plain disabled={!hasChanges} onClick={onDiscard} testId="discard-button">
        Discard
      </Button>
      <Button
        primary
        disabled={!isValid || isSubmitting || !hasChanges}
        loading={isSubmitting}
        onClick={onSave}
        testId="save-button"
      >
        Save changes
      </Button>
    </div>
  );
};

export default FormActions;
